var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.$t('message.orderFormFull.newOrder'),"header-class":"py-2","body-class":"order-modal-body","dialog-class":"order-modal-dialog","content-class":"order-modal-content","visible":_vm.visible,"no-close-on-backdrop":"","scrollable":"","hide-footer":true},on:{"hidden":_vm.hide}},[_c('order-form-papu-3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }